import CaptureBusinessMappingDataPoints from "classes/CaptureBusinessMappingDataPoints";
import CaptureLOCBusinessMappingDataPoints from "classes/CaptureLOCBusinessMappingDataPoints";
import CaptureLOCMappingDataPoints from "classes/CaptureLOCMappingDataPoints";

export default class Util {

    /**
     * @name inDesktopView
     * @static
     * @returns {BOOLEAN}
     * @description Getter to return a boolean if the demo is currently
     * in a desktop view determined by the window width.
     */
    static get inDesktopView() {
        return window.innerWidth > 750;
    }

        /**
     * @name replaceDOMDataPointValues
     * @static
     * @returns {VOID}
     * @description Replaces existing data point values in the dom using object "branding".
     * This function was added since all existing consumer data points needed to map to business data points
     * when business only branding is on.
     * @example         
        export default function CaptureQuickTourAccounts(props) {
            const context = useBCMSContext();
            BCMSRecord.globalControllerFor(Classes, context);
            const { branding } = context.state;

            useEffect(() => {
                Util.replaceDOMDataPointValues(branding);
            });
            return <AccountSummaryPage />
        }
     */
    static replaceDOMDataPointValues(branding) {
        const hasConsumerAccounts = branding.options.show_consumer_accts_abi22 === "true";
        const hasBusinessAccounts = branding.options.show_business_accounts_abi22 === "true";
        const loc_primary_abi22 = branding.options.loc_primary_abi22 === "true";
          let count = 0;
     
        if(!loc_primary_abi22 ) {
          if(!hasConsumerAccounts) {
              var dataPointInterval = setInterval(() => {
                  Object.keys(CaptureBusinessMappingDataPoints).map(dataPointKey => {
                      const dataPointValue = CaptureBusinessMappingDataPoints[dataPointKey];
                      const elem = document.querySelector(`[data-point="${ dataPointKey }"]`);
      
                          if(elem) {
                          elem.setAttribute("data-point", dataPointValue);
                      }
                      
                      if(count == 10) {
                          clearInterval(dataPointInterval);
                      }
                      count++;
                  });
              }, 500);
          }
      }else{
          if(!hasConsumerAccounts) {
            var dataPointInterval = setInterval(() => {
                Object.keys(CaptureLOCBusinessMappingDataPoints).map(dataPointKey => {
                    const dataPointValue = CaptureLOCBusinessMappingDataPoints[dataPointKey];
                    const elem = document.querySelector(`[data-point="${ dataPointKey }"]`);
    
                        if(elem) {
                        elem.setAttribute("data-point", dataPointValue);
                    }
                    
                    if(count == 10) {
                        clearInterval(dataPointInterval);
                    }
                    count++;
                });
            }, 500);
        }else{
          var dataPointInterval = setInterval(() => {
            Object.keys(CaptureLOCMappingDataPoints).map(dataPointKey => {
                const dataPointValue = CaptureLOCMappingDataPoints[dataPointKey];
                const elem = document.querySelector(`[data-point="${ dataPointKey }"]`);

                    if(elem) {
                    elem.setAttribute("data-point", dataPointValue);
                }
                
                if(count == 10) {
                    clearInterval(dataPointInterval);
                }
                count++;
            });
        }, 500);
        }
      }
    };

    /**
     * @name inMabi
     * @static
     * @returns {BOOLEAN}
     * @description Getter to return a boolean if the demo is currently within mabi
     */
    static get inMabi() {
        try {
            return window.parent.location.href.indexOf("mabi23") !== -1;
        } catch(e) {
            if (window.parent){
                return window.location.href.indexOf("localhost") !== -1;
            }
            return false;
        }
    }
    /**
     * @name routeMabi
     * @static
     * @returns {STRING}
     * @description function that sends message to mabi wrapper to route to a new page
     */
    static  routeMabi(route){
            let newSrc ={route:route,key:Date.now()};   
            if(this.inMabi){
                 window.parent.postMessage({message:"force-global-route",detail: {
                    route: `/${route}`
                }   
                },"*");
            }        
           
        
      }
    /**
     * @name openMabiChat
     * @static
     * @returns {STRING}
     * @description function that sends message to mabi wrapper to open chat in new window
     */
    static  openMabiChat(route){
        let newSrc ={route:route,key:Date.now()};   
        if(this.inMabi){
             window.parent.postMessage({message:"openMabiChat"},"*");
        }        
       
    
  }

    /**
     * @name openORIGInMABI23
     * @static
     * @returns {STRING}
     * @description Function that sends a message to parent MABI23 to open
     * ORIG19 or ORIG20 (depending on ABI22 branding) in a new window
     * in a MABI23 phone wrapper.
     */
    static openORIGInMABI23() {
        if(this.inMabi) window.parent.postMessage({ message: "openORIGInMABI23" }, "*");
    }

    /**
     * @name openABI22StandaloneOverlayInMABI23
     * @static
     * @returns {STRING}
     * @description Function that sends a message to parent MABI23 to open
     * another instance of ABI22 as an overlay that appears in MABI23.
     * For now, it's used when clicking the "Cards" link in ABI22
     * when integreated in MABI23, and then CH21 appears 
     * as a standalone app in MABI23.
     */
    static openABI22StandaloneOverlayInMABI23() {
        window.parent.postMessage({ message: "openABI22StandaloneIframe", pageID: "ch21Standalone" }, "*");
    }

    /**
     * @name openMabiEDEStatements
     * @static
     * @returns {STRING}
     * @description Function that sends a message to parent MABI23 to open
     * EDE Statements in a new window in a MABI23 phone wrapper.
     */
    static openMabiEDEStatementsInMABI23() {
        window.parent.postMessage({ message: "openEDEStatements", pageID: "edeStatements" }, "*");
    }

    /**
     * @name openMabiEDEStatements
     * @static
     * @returns {STRING}
     * @description Function that sends a message to parent MABI23 to close the current window.
     * Currently used in the EDE Statements "Sign Out" menu item.
     */
    static closeWindowInMABI23() {
        window.parent.postMessage({ message: "closeWindowInMABI23" }, "*");
    }

    /**
     * @name getMABI23Branding
     * @static
     * @returns {STRING}
     * @description Function that returns the branding passed by the parent MABI23.
     * Comp id "PageContainer" initially sets "mabi23Branding" in the window object
     * which gives the rest of the components access to MABI23 branding.
     * @example 
       const mabi23Branding = Util.getMABI23Branding();
       let mabi23Options = {};
     
       if(mabi23Branding) {
         mabi23Options = mabi23Branding.options;
       }
     */
    static getMABI23Branding() {
      return window.mabi23Branding;
    }

    /**
     * @name hideMABI23BottomNav
     * @static
     * @returns {VOID}
     * @description Function that listens to a message to mabi23 to hide/show the bottom nav.
     * It is needed in the "Deposits" workflow where the camera view needs 
     * to take up the entire screen view.
     */
    static hideMABI23BottomNav(hide) {
        if(this.inMabi) {
            window.parent.postMessage({ message: {
                hideMABI23BottomNav: (hide === true || hide === "true") ? "true" : "false"
            }}, "*");
        }
    }
   
    static getClickTrace(options,xml) {
      const _xml = xml,
            _options = options; 
    return( identifier)=>{
        const xmlDoc = _xml;
        const options = _options;
        const selector = options[identifier]??identifier;
        const xpath = `//*[@id="${selector}"]`;
       
        if (selector !== "undefined" && selector !== undefined && selector !== null) {
       
          // Use xpath with document.evaluate, etc.
        } else {
          document.write("Invalid identifier:", selector);
        }
        const node = xmlDoc.evaluate(
          xpath,
          xmlDoc,
          null,
          XPathResult.FIRST_ORDERED_NODE_TYPE,
          null
        ).singleNodeValue;
       
        if (!node) {
          document.write("No element found with id:", selector);
          return [];
        }
      
        const clickPath = [];
        let current = node;
      
        while (current && current.nodeType === Node.ELEMENT_NODE) {
          const dp = current.getAttribute("datapoint");
          const id = current.getAttribute("id");
      
        
          if (current.tagName === "subnav") {
          
            const itemSibling = current.firstElementChild;
            if (itemSibling) {
              const dp2 = itemSibling.getAttribute("datapoint");
              const id2 = itemSibling.getAttribute("id");
              if (dp2||id2) {
                clickPath.unshift({
                    selector: dp2
                    ? `[data-point='${dp2}'] [clickable]`
                    : `[clickable='${id2}']`,
                  label: dp2 || id2,
                  target :id2 === selector
                });
                current = current.parentNode;
                continue;    
              }
            }

          }
          if (dp || id) {
            clickPath.unshift({
              selector: dp
                ? `[data-point='${dp}'] [clickable]`
                : `[clickable='${id}']`,
              label: dp || id,
             target :id === selector
            });
            current = current.parentNode;
            continue;
          }
          // Also include nearest <item> sibling to <items> if applicable
          if (current.tagName === "items") {
            const itemSibling = [...current.parentNode.children].find(
              el => el.tagName === "item" && el.hasAttribute("datapoint")
            );
            if (itemSibling) {
              const dp2 = itemSibling.getAttribute("datapoint");
              const id2 = itemSibling.getAttribute("id");
              if (dp2||id2) {
                clickPath.unshift({
                    selector: dp2
                    ? `[data-point='${dp2}'] [clickable]`
                    : `[clickable='${id2}']`,
                  label: dp2 || id2,
                  target :id2 === selector
                });
                current = current.parentNode;
                continue;
              }
            }
          }
      
          current = current.parentNode;
        }
      
       
     let lastElement = clickPath.pop();
     const waitEventName = 'click';
     window.dispatchEvent(new CustomEvent('startClicks', {
      detail: { clickPath }
    }));
        /**clickPath.forEach(({ selector, label,target }) => {
          const el = document.querySelector(selector);
          if (el) {
            el.click();
          
           
            console.log(`Clicked: ${selector}`);
          } else {
            console.warn(`Missing element: ${selector}`);
          }
        });
      **/ 
      
      
        return clickPath.map(({ label }) => `Click on: ${label}`);
    }
      }
}

/**
 * Waits for the given selector to appear anywhere under `root` (defaults to document.body).
 * Resolves with the element, or rejects after `timeout` ms.
 */
export function waitForSelector(
  selector,
  { root = document.body, timeout = 500 } = {}
) {
  return new Promise((resolve, reject) => {
    // If it’s already there, bail out early
    const existing = root.querySelector(selector);
    if (existing) return resolve(existing);

    const observer = new MutationObserver(() => {
      const el = root.querySelector(selector);
      if (el) {
        observer.disconnect();
        resolve(el);
      }
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
    });

    // give up after `timeout`
    const id = setTimeout(() => {
      observer.disconnect();
      reject(new Error(`Timed out waiting for selector "${selector}"`));
    }, timeout);

    // cleanup on resolve/reject
    const cleanup = () => clearTimeout(id);
    resolve = (orig => val => (cleanup(), orig(val)))(resolve);
    reject  = (orig => err => (cleanup(), orig(err)))(reject);
  });
}

/**
 * Walks your array of { selector } objects: for each one,
 *  1) wait for it to appear
 *  2) click it
 *  3) immediately move on to the next
 */
export async function processClickPath(clickPath = []) {
  if (!Array.isArray(clickPath)) {
    console.warn('processClickPath: clickPath must be an array');
    return;
  }

  for (const { selector } of clickPath) {
    let el;

    try {
      el = await waitForSelector(selector);
    } catch (err) {
      console.warn(err.message);
      continue; // skip if it never shows up
    }

    el.click();
    console.log(`Clicked: ${selector}`);
  }
}